import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d8bcca0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-tab is-sticky" }
const _hoisted_2 = { class: "resume_sticky_button" }
const _hoisted_3 = { class: "resume_sticky_button_inner" }

import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import EducationSkill from '@/components/EducationSkill.vue';
import {
  getLangSkill,
  getQualificationInfo,
  getUsableLanguage,
  getUsableSoftware,
  QualificationInfo,
  LangSkill,
  UsableSoftware,
  UsableLanguage,
} from '@/api/careersheetEndpoint';
import { getMasterDataLangSkl, getMasterOtrLang, MasterDataLangSkl, MasterDataOtrLang } from '@/api/masterDataEndpoint';
import { putUpdateProvisionAndCareersheet } from '@/api/accountEndpoint';

import store from '@/store';
import { Ref, ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'EducationSkillView',
  setup(__props) {

const router = useRouter();
const isLoading = ref(false);

const qualification: Ref<QualificationInfo> = ref({ drLicenseFlg: false, qualificationList: [] });
const langSkill: Ref<LangSkill> = ref({
  engsklId: null,
  otrlang1Id: null,
  otrlang2Id: null,
  otrlang3Id: null,
});
const mstLangSkl: Ref<MasterDataLangSkl[]> = ref([]);
const mstOtrLang: Ref<MasterDataOtrLang[]> = ref([]);
const usableSoft: Ref<UsableSoftware> = ref({
  osWindowsFlg: false,
  osMacFlg: false,
  osUnixFlg: false,
  msWordFlg: false,
  msExcelFlg: false,
  msPowerpointFlg: false,
  msAccessFlg: false,
  photoshopFlg: false,
  illustratorFlg: false,
  inDesignFlg: false,
  dreamweaverFlg: false,
  adobeXDFlg: false,
  sketchFlg: false,
  figmaFlg: false,
  afterEffectsFlg: false,
  lightroomFlg: false,
  premiereFlg: false,
  finalCutProFlg: false,
  ediusFlg: false,
  unityFlg: false,
  threeDCgFlg: false,
  cadFlg: false,
  googleAnalyticsFlg: false,
  googleSearchConsoleFlg: false,
  biFlg: false,
  statisticalAnalysisFlg: false,
  sfaFlg: false,
  maFlg: false,
  cloudPlatFormFlg: false,
});
const usableLang: Ref<UsableLanguage> = ref({
  langCFlg: false,
  cplusplusFlg: false,
  csharpFlg: false,
  javaFlg: false,
  phpFlg: false,
  sqlFlg: false,
  aspFlg: false,
  javascriptFlg: false,
  htmlFlg: false,
  xmlFlg: false,
  xhtmlFlg: false,
  cssFlg: false,
  sassFlg: false,
  ftpFlg: false,
  wordPressFlg: false,
  movableTypeFlg: false,
  langRFlg: false,
  perlFlg: false,
  rubyFlg: false,
  goFlg: false,
  pythonFlg: false,
  swiftFlg: false,
  kotlinFlg: false,
});

// 取得処理
const init = async () => {
  isLoading.value = true;
  try {
    const [qualificationRes, langSkillRes, mstLangSklRes, mstOtrLangRes, usableSoftRes, usableLangRes] = await Promise.all([
      // TODO: getHogeHogeではなく、storeのaction,gettersで実装する
      getQualificationInfo(),
      getLangSkill(),
      getMasterDataLangSkl(),
      getMasterOtrLang(),
      getUsableSoftware(),
      getUsableLanguage(),
      // 学歴
      store.dispatch('careerSheetEducation/getAcademicInfo'),
      store.dispatch('master/getMasterDataListLstSchl'),
      store.dispatch('master/getMasterDataListEntrance'),
      store.dispatch('master/getMasterDataListGrad'),
      store.dispatch('userMenu/receive'),
      // 携わったことのあるクライアント業種
      store.dispatch('careerSheetBusinesstype/getBusinesstypeList'),
    ]);

    qualification.value = qualificationRes;
    langSkill.value = langSkillRes;
    mstLangSkl.value = mstLangSklRes;
    mstOtrLang.value = mstOtrLangRes;
    usableSoft.value = usableSoftRes;
    usableLang.value = usableLangRes;
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

// ホーム画面へ移動
const transitionHome = async () => {
  isLoading.value = true;
  try {
    if (!store.getters['userMenu/initialRegistration']) {
      // 初回登録時は叩かない
      await putUpdateProvisionAndCareersheet();
    }
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
    router.push({ name: 'f00' });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!isLoading.value)
            ? (_openBlock(), _createBlock(EducationSkill, {
                key: 0,
                qualificationRes: qualification.value,
                langSkillRes: langSkill.value,
                mstLangSklRes: mstLangSkl.value,
                mstOtrLangRes: mstOtrLang.value,
                usableSoftRes: usableSoft.value,
                usableLangRes: usableLang.value
              }, null, 8, ["qualificationRes", "langSkillRes", "mstLangSklRes", "mstOtrLangRes", "usableSoftRes", "usableLangRes"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(BaseButton, {
                theme: "primary",
                onClick: transitionHome
              }, {
                default: _withCtx(() => [
                  _createTextVNode("この内容でOKです")
                ]),
                _: 1
              })
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})